var React = require('react');

function FreeZoneServicesArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.11156e-06 435.078C47.0011 388.077 280.87 154.13 435 0L435 29.3581L34.9961 434.867L435 847.715L435 869.733L2.11156e-06 435.078Z","fill":"#CE435B","key":0}),React.createElement("path",{"d":"M22.0186 435.078C69.0197 388.077 280.87 183.488 435 29.3581V69.7254L64.3542 434.867L435 800.008L435 847.715L22.0186 435.078Z","fill":"#CE435B","key":1})]);
}

FreeZoneServicesArrow.defaultProps = {"width":"435","height":"870","viewBox":"0 0 435 870","fill":"none"};

module.exports = FreeZoneServicesArrow;

FreeZoneServicesArrow.default = FreeZoneServicesArrow;
